import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';
import { Directive, OnInit, Input} from '@angular/core';
@Directive({
  selector: '[appNumberInputRangeValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: NumberInputRangeValidator, multi: true }
  ]
})
export class NumberInputRangeValidator implements Validator {
@Input() min: number;
@Input() max: number;
  validate(c: AbstractControl) {
      const value  = Number(c.value);
      if (!(value >= this.min &&  value <= this.max)) {
        return { 'notInRange': true, min: this.min, max: this.max};
      }
      return null;
  }
}
